<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('documents')" :isFilter="false" :isColumns="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('documents')" :isFilter="false" :isColumns="false" />
            </template>
<!--            <div class="mb-2 border rounded p-2 text-center bg-dark text-white">-->
<!--                {{ user.student_number }} - {{ user.name }} {{ user.surname }}-->
<!--            </div>-->
            <b-row>
                <template v-for="(item, itemKey) in computeDocuments(user)">
                    <b-col cols="12" md="6" :key="'document' + itemKey" v-if="checkPermission(item.permission)">
                        <div v-if="item.hiddenIcon">
                            <b-dropdown class="mb-2" block split split-variant="outline-dark" variant="dark" right :text="item.text">
                                <b-dropdown-item @click="openModal(item, lang)"
                                                 v-for="(lang, langKey) in item.language"
                                                 :key="'lang' + langKey">
                                    {{ $t(lang) }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div v-else>
                            <b-dropdown class="mb-2" block split split-variant="outline-dark" variant="dark" right
                                        :text="item.text.toUpper()">
                                <b-dropdown-item @click="item.callback(lang)"
                                                 v-for="(lang, langKey) in item.language"
                                                 :key="'lang' + langKey">
                                    {{ $t(lang) }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </b-col>
                </template>
            </b-row>
            <CommonModal ref="semesterModal" size="md" :onHideOnlyX="true">
                <template v-slot:CommonModalContent>
                    <ValidationObserver ref="formModalValidate">
                        <b-row>
                            <b-col cols="12">
                                <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('semester')">
                                        <semesters-selectbox v-model="semesterForm.semester_id"
                                                             :is-student="isStudent"
                                                             :validate-error="errors[0]"></semesters-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                    <b-form-group>
                        <b-button class="float-right" variant="primary" @click="confirmSemester">{{ $t('view') }}</b-button>
                    </b-form-group>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
import documentData from "@/modules/students/data/Documents";
import AppLayout from "@/layouts/AppLayout.vue";
import Header from "@/layouts/AppLayout/Header.vue";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
    },
    metaInfo() {
        return {
            title: this.$t("documents"),
        }
    },
    data() {
        return {
            semesterForm: {
                semester_id: null,
                item: null,
                lang: null
            },
        }
    },
    computed:{
        user(){
            return this.$store.getters['auth/getUser'];
        },
        isStudent() {
            return this.$store.getters['auth/isStudent'];
        },
    },
    methods: {
        computeDocuments(user) {
            let documents = [];
            if (this.user && this.user.id && this.user.student?.student_number) {
                if (user.registration_type == 212) {
                    documents = documentData(this.user).filter(
                        (document) => document.permission !== "studentdocument_militarystatus"
                    );
                } else {
                    if (!['EN'].includes(user.program_language)){
                        documents = documentData(this.user).filter((document) => document.slug !== "medium_of_instruction");
                    }else{
                        documents = documentData(this.user);
                    }
                }
            }
            return documents;
        },
        openModal(item, lang) {
            this.semesterForm.item = item
            this.semesterForm.lang = lang
            this.semesterForm.semester_id = null
            this.$refs.semesterModal.$refs.commonModal.show()
        },
        async confirmSemester() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                if (this.semesterForm.item && this.semesterForm.lang) {
                    this.semesterForm.item.callback(this.semesterForm.lang, this.semesterForm.semester_id)
                }
                this.$refs.semesterModal.$refs.commonModal.hide()
            }
        }


    }
}
</script>
